<template>
  <div class="steps">
    <div class="row row u-justify-content-center">
      <div class="col-12 col-md-8 col-lg-10">
        <h1 class="u-text-align-center">{{ $t('coldroom.select') }}</h1>
      </div>
      <div class="row u-justify-content-center">
        <div class="col-12 col-md-8 col-lg-4 u-display-flex">
          <StepOptions
            :img="nt_icon"
            :text="$t('coldroom.normal_temperature.description')"
            :label="$t('coldroom.normal_temperature.label')"
            @click="openNormalTemp"
          ></StepOptions>
        </div>
        <div class="col-12 col-md-8 col-lg-4 u-display-flex">
          <StepOptions
            :img="lt_icon"
            :text="$t('coldroom.low_temperature.description')"
            :label="$t('coldroom.low_temperature.label')"
            @click="openLowTemp"
          ></StepOptions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepOptions from "./StepOptions";

export default {
  name: "FirstStep",
  props: [
    'openNormalTemp',
    'openLowTemp',
  ],
  components: {
    StepOptions,
  },
  computed: {
    nt_icon() {
      return '<i class="icon-normal_temp"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></i>';
    },
    lt_icon() {
      return '<i class="icon-low_temp"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></i>';
    }
  }
}
</script>
